import { render, staticRenderFns } from "./AgentSidebarItem.vue?vue&type=template&id=12589549&"
import script from "./AgentSidebarItem.vue?vue&type=script&lang=js&"
export * from "./AgentSidebarItem.vue?vue&type=script&lang=js&"
import style0 from "./AgentSidebarItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports